import { type FormEvent } from 'react';
import { Send } from 'lucide-react';
import { Modal } from '../../components/Modal.tsx';
import { CONTACT_EMAIL, buildContactMailto } from './landingData.ts';

interface Props {
  open: boolean;
  subject: string;
  name: string;
  email: string;
  message: string;
  setName: (value: string) => void;
  setEmail: (value: string) => void;
  setMessage: (value: string) => void;
  onClose: () => void;
  onSubmitted: () => void;
}

export function LandingContactModal({
  open,
  subject,
  name,
  email,
  message,
  setName,
  setEmail,
  setMessage,
  onClose,
  onSubmitted,
}: Props) {
  function submitContact(event: FormEvent) {
    event.preventDefault();
    window.location.href = buildContactMailto({ subject, name, email, message });
    onSubmitted();
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={<span>Book a <span className="serif-accent">walkthrough</span></span>}
      maxWidth={540}
      footer={
        <>
          <button className="btn-ghost" type="button" onClick={onClose}>
            Cancel
          </button>
          <button className="btn-primary" type="submit" form="contact-form">
            Send request <Send size={15} />
          </button>
        </>
      }
    >
      <p className="contact-intro">
        Tell us what you run and we will set up a live walkthrough against a real ATRIUM panel.
        Submitting opens a prefilled draft to <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
      </p>
      <form id="contact-form" className="contact-form" onSubmit={submitContact}>
        <label className="contact-field">
          <span className="contact-label">Name</span>
          <input
            type="text"
            value={name}
            onChange={(event) => setName(event.target.value)}
            placeholder="Jordan Vega"
            autoComplete="name"
          />
        </label>
        <label className="contact-field">
          <span className="contact-label">Work email</span>
          <input
            type="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            placeholder="jordan@portfolio.com"
            autoComplete="email"
            required
          />
        </label>
        <label className="contact-field">
          <span className="contact-label">What are you running?</span>
          <textarea
            value={message}
            onChange={(event) => setMessage(event.target.value)}
            placeholder="14 ATRIUM sites, 600 doors, replacing a VPN-heavy operations stack."
            rows={4}
          />
        </label>
      </form>
    </Modal>
  );
}
